<template>
<v-container>
    <v-row no-gutters>
        <v-col cols="6" class="px-2">
            <v-text-field outlined placeholder=" " v-model="origin" dense label="From">
            </v-text-field>
        </v-col>
        <v-col cols="6" class="px-2">
            <v-text-field outlined placeholder=" " v-model="destination" dense label="To">
            </v-text-field>
        </v-col>
        <v-col cols="12" class="pa-2">
            <iframe width="100%" height="500px" src=""></iframe>
        </v-col>
    </v-row>
</v-container>
</template>
<script>
export default {
    data(){
        return{
            origin : "myanmar",
            destination: "myanmar info lite",
            url: "https://www.google.com/maps/embed/v1/directions"
        }
    }
}
</script>